import { skills } from '../data/portfolio';
import { FadeUp } from './Reveal';

export default function SkillsBento() {
    return (
        <section id="stack" data-testid="skills-section" className="relative z-10 bg-ink py-24 md:py-32">
            <div className="mx-auto max-w-[1300px] px-6">
                <FadeUp>
                    <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-neon">
                        The Stack I Carry
                    </p>
                    <h2 className="mt-4 max-w-2xl font-display text-3xl font-extrabold leading-tight text-snow md:text-5xl">
                        Learned everywhere. Carried into everything.
                    </h2>
                    <p className="mt-4 max-w-xl text-sm text-mist md:text-[15px]">
                        Inferred from the journey above; this grid grows as the work grows, and it is never a stagnant list.
                    </p>
                </FadeUp>

                <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-6">
                    {skills.map((s, i) => (
                        <FadeUp key={s.name} delay={i * 0.06} className={`${s.span} h-full`}>
                            <article
                                data-testid={`skill-card-${i}`}
                                className="group flex h-full flex-col justify-between rounded-2xl border border-white/[0.08] bg-panel p-7 transition-all duration-300 hover:-translate-y-1 hover:bg-panel2"
                                style={{ ['--acc']: s.accent }}
                            >
                                <div className="flex items-start justify-between gap-4">
                                    <div>
                                        <span className="font-mono text-[10px] uppercase tracking-[0.24em]" style={{ color: s.accent }}>
                                            {s.category}
                                        </span>
                                        <h3 className="mt-2.5 font-display text-xl font-bold text-snow md:text-2xl">
                                            {s.name}
                                        </h3>
                                    </div>
                                    <span
                                        className="rounded-full border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em]"
                                        style={{ borderColor: `${s.accent}44`, color: s.accent }}
                                    >
                                        {s.level}
                                    </span>
                                </div>
                                <p className="mt-5 text-sm leading-relaxed text-mist">{s.desc}</p>
                                <div
                                    className="mt-6 h-px w-full origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100"
                                    style={{ background: `linear-gradient(90deg, ${s.accent}, transparent)` }}
                                />
                            </article>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
